/*
 * Author: Harper Yan
 * File Created: Friday, 25-03-07 10:00 am
 * Last Modified: Thursday, 25-03-27 11:40 am, by Harper Yan
 */
export type ENV = 'local' | 'dev' | 'qa' | 'preprod' | 'prod';

export function getEnv(): ENV {
  if (typeof window !== 'undefined') {
    const { hostname } = location;
    if (/^(localhost|127\.0\.0\.1)(:\d+)?$/.test(hostname)) {
      return 'local';
    }
    return process.env.APP_ENV as ENV;
  }
  return process.env.NODE_ENV === 'development'
    ? 'local'
    : (process.env.APP_ENV as ENV);
}

export default getEnv;

export const isClient = (function () {
  try {
    return typeof window !== 'undefined';
  } catch (e) {
    return true;
  }
})();

export const isServer = !isClient;
